import Axios from 'axios'
import api from '@/services/api'
import route from '../router'


export default {
    namespaced: true,
    state: {
        user: null ,
        password: null,
    },
    mutations: {
        SET_LOGIN ( state , payload) {
            state.user =payload.user
            state.password = payload.password
        }
    },
    actions: {
        create_user: async ({commit, state }, payload)  =>{
            try{
                let data = (await Axios.post(api.baseUrl + 'users/signup', payload)).data
                if (data.error) {
                    console.log(data.error)
                }
                else {
                    console.log(data.result)
                    route.push({path: '/login'})
                }
            } catch (err){
                alert(err)
                console.log(err.response.data.error)
            }
            
            // if (data.status == 200) {
            //     commit('SET_COMPANY', data)
            // }
            
            commit('SET_LOGIN', payload)
            //state.user = payload.user
           // console.log(state.user)
        },
        fetchUser: async ({ commit, state}, payload) => {
            let data =await Axios.post(api.baseUrl + 'users/login',  payload )
            if (data.status == 200) {
                
            }
        }
    }
}
